
import { useState, useEffect } from 'react';
import { DoctorStatisticsData } from '@/types/doctor-statistics';

export const useStatisticsData = (dateRange: string): DoctorStatisticsData => {
  const [data, setData] = useState<DoctorStatisticsData>({
    overviewStats: {
      totalPatients: 148,
      patientsChange: 12,
      plansSent: 83,
      plansSentChange: 5,
      plansAccepted: 67,
      plansAcceptedChange: 8,
      totalIncome: 156500,
      incomeChange: 15
    },
    conversionData: {
      casesReceived: 120,
      plansSent: 83,
      plansAccepted: 67,
      casesCompleted: 54,
      plansSentPercent: 69,
      plansAcceptedPercent: 56,
      casesCompletedPercent: 45
    },
    incomeData: {
      monthlyData: [
        { month: 'Jan', income: 19500 },
        { month: 'Feb', income: 21200 },
        { month: 'Mar', income: 25800 },
        { month: 'Apr', income: 28500 },
        { month: 'May', income: 31000 },
        { month: 'Jun', income: 30500 }
      ],
      ytdTotal: 156500
    },
    adPerformance: {
      totalImpressions: 8450,
      totalClicks: 685,
      totalInquiries: 42,
      byAdType: [
        {
          type: 'Featured Story',
          impressions: 4230,
          clicks: 385,
          inquiries: 22,
          conversionRate: 5.7
        },
        {
          type: 'Top Doctor',
          impressions: 2850,
          clicks: 210,
          inquiries: 15,
          conversionRate: 7.1
        },
        {
          type: 'Before/After Gallery',
          impressions: 1370,
          clicks: 90,
          inquiries: 5,
          conversionRate: 5.6
        }
      ]
    },
    patientSourceData: {
      organicViews: 85,
      sponsoredAds: 28,
      clinicReferrals: 22,
      redistributedCases: 9,
      otherSources: 4,
      total: 148
    },
    isAdsActive: true,
    adInsights: {
      activeAds: 3,
      totalImpressions: 8450,
      ctr: 8.1, // 685 clicks / 8450 impressions
      leadsGenerated: 42,
      changePercent: 15
    }
  });

  useEffect(() => {
    // This would typically be an API call that fetches data based on the date range
    // For this example, we're just simulating with static data
    console.log(`Fetching statistics data for range: ${dateRange}`);
    
    // In a real app, you would make your API call here
    // For now, we're just using the default data
  }, [dateRange]);

  return data;
};
